export const MIN_SQFT = [
  { label: '250', value: 250 },
  { label: '500', value: 500 },
  { label: '1,000', value: 1000 },
  { label: '1,100', value: 1100 },
  { label: '1,200', value: 1200 },
  { label: '1,300', value: 1300 },
  { label: '1,400', value: 1400 },
  { label: '1,500', value: 1500 },
  { label: '1,600', value: 1600 },
  { label: '1,700', value: 1700 },
  { label: '1,800', value: 1800 },
  { label: '1,900', value: 1900 },
  { label: '2,000', value: 2000 },
  { label: '2,250', value: 2250 },
  { label: '2,500', value: 2500 },
  { label: '2,750', value: 2750 },
  { label: '3,000', value: 3000 },
  { label: '4,000', value: 4000 },
  { label: '5,000', value: 5000 },
  { label: '7,500', value: 7500 },
  { label: '10,000', value: 10000 },
];

export const MAX_SQFT = [
  { label: '1,000', value: 1000 },
  { label: '1,100', value: 1100 },
  { label: '1,200', value: 1200 },
  { label: '1,300', value: 1300 },
  { label: '1,400', value: 1400 },
  { label: '1,500', value: 1500 },
  { label: '1,600', value: 1600 },
  { label: '1,700', value: 1700 },
  { label: '1,800', value: 1800 },
  { label: '1,900', value: 1900 },
  { label: '2,000', value: 2000 },
  { label: '2,250', value: 2250 },
  { label: '2,500', value: 2500 },
  { label: '2,750', value: 2750 },
  { label: '3,000', value: 3000 },
  { label: '4,000', value: 4000 },
  { label: '5,000', value: 5000 },
  { label: '7,500', value: 7500 },
  { label: '10,000', value: 10000 },
];

export const LOT_MIN = [
  { label: '2,000 sqft', value: 2000 },
  { label: '4,500 sqft', value: 4500 },
  { label: '6,500 sqft', value: 6500 },
  { label: '8,000 sqft', value: 8000 },
  { label: '9,500 sqft', value: 9500 },
  { label: '.25 acres', value: 10890 },
  { label: '.5 acres', value: 21780 },
  { label: '1 acres', value: 43560 },
  { label: '2 + acres', value: 87120 },
  { label: '3 acres', value: 130680 },
  { label: '4 acres', value: 174240 },
  { label: '5 acres', value: 217800 },
  { label: '10 acres', value: 435600 },
  { label: '20 acres', value: 871200 },
  { label: '40 acres', value: 1742400 },
  { label: '100 acres', value: 4356000 },
];

export const LOT_MAX = [
  { label: '2,000 sqft', value: 2000 },
  { label: '4,500 sqft', value: 4500 },
  { label: '6,500 sqft', value: 6500 },
  { label: '8,000 sqft', value: 8000 },
  { label: '9,500 sqft', value: 9500 },
  { label: '.25 acres', value: 10890 },
  { label: '.5 acres', value: 21780 },
  { label: '1 acres', value: 43560 },
  { label: '2 + acres', value: 87120 },
  { label: '3 acres', value: 130680 },
  { label: '4 acres', value: 174240 },
  { label: '5 acres', value: 217800 },
  { label: '10 acres', value: 435600 },
  { label: '20 acres', value: 871200 },
  { label: '40 acres', value: 1742400 },
  { label: '100 acres', value: 4356000 },
];

export const GARAGE_SPOTS = [
  { id: 0, label: 'Any', value: null },
  { id: 1, label: '1+', value: 1 },
  { id: 2, label: '2+', value: 2 },
  { id: 3, label: '3+', value: 3 },
  { id: 4, label: '4+', value: 4 },
];
